import en from './en.json';
import pl from './pl.json';
import ru from './ru.json';
import ua from './ua.json';

export const LANGS = ['en', 'ua', 'pl', 'ru'] as const;
export type Lang = (typeof LANGS)[number];
export type MessageKey = keyof typeof en;
export type MessageParams = Record<string, string | number>;

const DICTS: Record<Lang, Partial<Record<MessageKey, string>>> = { en, ua, pl, ru };

/** Localised text for a key. Unknown language or missing key falls back to EN, then to the key itself. */
export function t(key: MessageKey, lang: Lang, params?: MessageParams): string {
  const text = DICTS[lang]?.[key] ?? en[key] ?? key;
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, (m, name: string) => (name in params ? String(params[name]) : m));
}
